<template>
  <section>
    <grupopcion-form
      :is-add-grupo-opcion-sidebar.sync="isAddGrupoOpcionSidebar"
      :form-type="formTypeGo"
      :data-edit="dataEdit"
      @refetch-data="refetchDataGo"
      @error-data="showError"
    />
    <b-row class="match-height">
      <b-col
        lg="4"
        md="6"
      >
        <b-card
          class="card-transaction"
          no-body
        >
          <b-card-header>
            <b-card-title>Grupo Opción</b-card-title>

            <b-button
              variant="primary"
              @click="openFormGrupoOpcion('new')"
            >
              <span class="text-nowrap">Nuevo</span>
            </b-button>
          </b-card-header>

          <b-card-body>
            <div
              v-if="isBusyGo"
              class="text-center text-primary my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">Cargando...</strong>
            </div>
            <div style="height:715px;overflow:scroll;">
              <div
                v-for="(go, index) in itemsGo"
                :key="index"
                class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                      rounded
                      size="42"
                      :variant="getColor()"
                    >
                      <feather-icon icon="GridIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="transaction-title">
                      {{ go.descripcion }}
                    </h6>
                  </b-media-body>
                </b-media>
                <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body cursor-pointer"
                    />
                  </template>
                  <b-dropdown-item @click="getOpcion(index , 'click')">
                    <feather-icon icon="ServerIcon" />
                    <span class="align-middle ml-50">Gestionar Opciones</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="getEditGrupoOpcion(go)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Editar</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="getDelete(go)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Eliminar</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="8">
        <opcion-list
          ref="listGrupos"
          :is-get-opcion.sync="isGetOpcion"
          :data-grupopcion="grupoOpcionSel"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BButton, BCard, BCardHeader, BCardTitle, BCardBody, BMediaBody, BMedia, BMediaAside, BAvatar, BDropdown, BDropdownItem, BRow, BCol, BSpinner } from 'bootstrap-vue'
import store from '@/store'
import OpcionList from './OpcionList.vue'
import GrupopcionForm from './GrupopcionForm.vue'

export default {
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BSpinner,
    OpcionList,
    GrupopcionForm,
  },
  data() {
    return {
      classColors: ['success', 'primary', 'danger', 'warning', 'info', 'secondary'],
      itemsGo: [],
      itemsM: [],
      dataEdit: {},
      isBusyGo: false,
      isBusyM: false,
      formTypeGo: '',
      isAddGrupoOpcionSidebar: false,
      isGetOpcion: false,
      grupoOpcionSel: {},
    }
  },
  async mounted() {
    await this.listarGrupoOpcion()
    if (this.itemsGo.length > 0) {
      this.getOpcion(0, 'init')
    }
  },
  methods: {
    getOpcion(index, process) {
      this.grupoOpcionSel = this.itemsGo[index]
      // console.log(`go: ${this.grupoOpcionSel.idGrupoOpcion}`)
      this.isGetOpcion = true
      if (process !== 'init') { // AUTOMATICO QUITAR ESTE IF
        // this.$refs.listGrupos.listarRegistros()
      }
    },
    async listarGrupoOpcion() {
      this.isBusyGo = true
      await store
        .dispatch('gsencuesta/GRUPO_OPCION_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
        })
        .then(response => {
          this.itemsGo = response
          this.isBusyGo = false
        })
        .catch(error => {
          this.showError(error)
          this.isBusyGo = false
        })
    },
    openFormGrupoOpcion(type) {
      this.formTypeGo = type
      this.isAddGrupoOpcionSidebar = true
    },
    getEditGrupoOpcion(data) {
      this.formTypeGo = 'edit'
      this.isAddGrupoOpcionSidebar = true
      this.dataEdit = data
    },
    refetchDataGo(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarGrupoOpcion()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.message
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    getClassColor(index) {
      return this.classColors[index - 1]
    },
    getColor() {
      let lista = [1, 2, 3, 4, 5]
      const color = ['secondary', 'success', 'primary', 'danger', 'warning']
      lista = lista.sort(() => Math.random() - 0.5)
      return color[lista[0]]
    },
    getDelete(data) {
      this.$swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/GRUPO_OPCION_DELETE', {
              id: data.idGrupoOpcion,
            })
            .then(response => {
              this.listarGrupoOpcion()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
</style>
